import {ISimpleColor, ICustomGradient, IGradientType} from "@consts/types";

export const defaultColor: ISimpleColor = {
  red: 0,
  green: 0,
  blue: 255,
  alpha: 1,
};

export const defaultGradient: ICustomGradient = {
  points: [
    {
      left: 0,
      red: 0,
      green: 255,
      blue: 0,
      alpha: 1,
    },
    {
      left: 100,
      red: 0,
      green: 100,
      blue: 255,
      alpha: 1,
    } ],
  degree: 0,
  type: IGradientType.linear,
};
